module.exports = __webpack_public_path__ + "img/badge.4efb2177.svg";